import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { StrikerBrand } from '@striker/ui-shell';

type WelcomePayload = {
  ownerEmail?: string;
  slug?: string;
  tenantId?: number;
};

function readWelcome(): WelcomePayload | null {
  try {
    const raw = sessionStorage.getItem('striker_registration_welcome');
    if (!raw) return null;
    return JSON.parse(raw) as WelcomePayload;
  } catch {
    return null;
  }
}

export function WelcomePage() {
  const data = useMemo(() => readWelcome(), []);

  return (
    <div className="sk-shift sk-register">
      <div className="sk-shift__glow" aria-hidden="true" />
      <header className="sk-shift__nav">
        <Link to="/" className="sk-shift__nav-brand" aria-label="StrikerPos">
          <StrikerBrand surface="dark" title="StrikerPos" />
        </Link>
      </header>

      <main className="sk-register__main">
        <p className="sk-shift__eyebrow">Benvenuto</p>
        <h1 className="sk-shift__section-title">Locale pronto</h1>
        <p className="sk-shift__section-lead">
          La registrazione è completata. Accedi con l’email owner per aprire la console e pubblicare la
          vetrina del locale.
        </p>
        {data?.ownerEmail ? (
          <p className="sk-shift__status">
            Account: <strong>{data.ownerEmail}</strong>
            {data.slug ? ` · slug /r/${data.slug}` : ''}
          </p>
        ) : null}
        <div className="sk-shift__hero-cta">
          <Link className="sk-shift__btn sk-shift__btn--primary" to="/login">
            Vai al login
          </Link>
          <Link className="sk-shift__btn sk-shift__btn--ghost" to="/">
            Home
          </Link>
        </div>
      </main>
    </div>
  );
}
